import React from "react";
import {
  List,
  Datagrid,
  TextField,
  DateField,
  EditButton,
  RefreshButton,
  Filter,
  TextInput,
  CreateButton
} from "admin-on-rest";
import { CardActions } from "material-ui/Card";

import { styles } from "./styles";
import "./index.css";

import IconTitle from "../components/icon_title";
import Pagination from "../components/pagination";

import { UserCreate as create, UserEdit as edit } from "./Create";

const UserActions = ({ resource, basePath, refresh }) => (
  <CardActions style={styles.cardActionStyleSmall} className="users-actions">
    <CreateButton basePath={basePath} />
    <RefreshButton basePath={basePath} refresh={refresh} />
  </CardActions>
);
const UserFilter = ({ ...props }) => (
  <Filter {...props}>
    <TextInput
      label="resources.orders.actions.search"
      source="search"
      alwaysOn
    />
  </Filter>
);

export const UserCreate = create;
export const UserEdit = edit;
const FullNameField = ({ record = {} }) => (
  <span>
    {record.first_name} {record.last_name}
  </span>
);
export const UsersList = props => (
  <List
    {...props}
    actions={<UserActions />}
    filters={<UserFilter />}
    title={<IconTitle icon="accounts" title={"resources.users.title"} />}
    pagination={<Pagination />}
  >
    <Datagrid bodyOptions={{ showRowHover: true }}>
      <FullNameField
        label="resources.users.fieldList.name"
        source="first_name"
      />
      <TextField label="resources.users.fieldList.email" source="email" />
      <TextField label="resources.users.fieldList.role.title" source="role" />
      <DateField
        label="resources.users.fieldList.create_at"
        source="created_at"
      />
      <EditButton label="" style={{ textAlign: "right" }} />
    </Datagrid>
  </List>
);



// WEBPACK FOOTER //
// ./src/users/index.js